import { render, staticRenderFns } from "./DataListSecurityEvalutions.vue?vue&type=template&id=a841514e&"
import script from "./DataListSecurityEvalutions.vue?vue&type=script&lang=js&"
export * from "./DataListSecurityEvalutions.vue?vue&type=script&lang=js&"
import style0 from "./DataListSecurityEvalutions.vue?vue&type=style&index=0&id=a841514e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports